import { PropLifecycleTracking } from '@calm/evexia-analytics';
import { useSearchParams } from 'next/navigation';

export const enum LifecycleTrackingLocation {
    Header = 'Header',
    SSOAuthFlow = 'SSO auth flow',
    HeroBanner = 'Hero banner',
    AuthPage = 'Auth Page',
}

interface UseLifecycleTrackingParamsOptions {
    location?: LifecycleTrackingLocation;
}

// Specific to CH - helps track to which client landing they are being brought to
const ACCESS_CODE = 'access_code';
// Enterprise lifecycle specific tracking UTM we add to Iterable sends
const ITERABLE_ID = 'af_c_id';
// Appsflyer parameter for campaigns tracking
const APPSFLYER_CAMPAIGN = 'c';

const useLifecycleTrackingParams = ({
    location,
}: UseLifecycleTrackingParamsOptions = {}): PropLifecycleTracking => {
    const searchParams = useSearchParams();
    const accessCode = searchParams.get(ACCESS_CODE);
    const iterableId = searchParams.get(ITERABLE_ID);
    const appsflyerCampaign = searchParams.get(APPSFLYER_CAMPAIGN);

    return {
        ...(location ? { location } : {}),
        AccessCode: accessCode ?? undefined,
        IterableId: iterableId ?? undefined,
        AppsflyerCampaign: appsflyerCampaign ?? undefined,
    };
};

export default useLifecycleTrackingParams;
